import client from '../../client';

export const deviceServiceApis = {
  getExtendHistory: (data: { mac: string }) => client.get(`/device/exp-history`, { params: data }),
  postExtendService: (data: any) => client.post(`/device/update-service-period`, data),
};
